export default __webpack_public_path__ + "tmp_src/components/ShopTheLook/ShopTheLook.css.liquid";